module.exports = __webpack_public_path__ + "static/video-making-h264-26d694be57c1f0e416678e6c4e9ebd80.mp4";